import React from 'react';

export default function Header() {
  return (
    <header>
      <h1 className="text-light title">
        <span role="img" aria-label="Italy Flag">
          🇮🇹
        </span>{' '}
        Italy Coronavirus Tracker
      </h1>
    </header>
  );
}
